import React, { useState, useRef, useEffect } from "react";
import "./style/bottomNav.css";
import { assets } from "../../../assets/assets";
import InfoMap from "../../modal/modal-info-map/InfoMap";
import NotesMap from "../../modal/modal-notes-map/notesMap";
import ItemNav from "../topnav/itemNav";
import { useLocation } from "react-router-dom";

function BottomNav({
  onCallbackClick,
  onShowRadiusClick,
  bottomValue = 0,
  hideShowRadius,
  onToggleOverlay,
  isOverlayHidden,
  btnLang,
  lang,
  onLandmarksClick,
  onRoadsClick,
  showPlaces,
  showRoads,
  isDevsActive,
  onDevsClick,
  onFilterChange,
  filterSelection,
  setProgressVilla,
  setSpinVilla,
  isExploreTour = false,


  projectSlug,
}) {
  const location = useLocation();
  const page = location?.pathname || "";

  const [isNotesOpen, setIsNotesOpen] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const navRef = useRef(null);

  const toggleNotes = () => {
    setIsNotesOpen((prev) => !prev);
    if (!isNotesOpen && isInfoOpen) setIsInfoOpen(false);
  };

  const toggleInfo = () => {
    setIsInfoOpen((prev) => !prev);
    if (!isInfoOpen && isNotesOpen) setIsNotesOpen(false);
  };

  const toggleFilter = () => {
    setIsFilterOpen((prev) => !prev);
  };
  useEffect(() => {}, [isFilterOpen]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsNotesOpen(false);
        setIsInfoOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isNotesOpen, isInfoOpen]);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };
  const handleFilterChange = (filterData) => {
    onFilterChange({
      mode: filterData.mode || null,
      data: filterData.data || [],
    });
  };

  return (
    <div
      className={`bottom-nav_ d-flex p-0 ${
        isExploreTour
          ? "explore-sticky-mode"
          : page?.startsWith("/master-plan")
            ? "master-mode"
            : "d-md-flex"
      }
      
      `}
      ref={navRef}
      style={{
        bottom: isExploreTour ? "0" : `${bottomValue}px`,
      }}
    >
      {!isExploreTour && !page.includes("/tour/") && (
      <div className="content-nav-">
        <div className="name-brand">
          <img
            src={assets.gravity}
            alt="Gravity Logo"
            className="gravity-logo"
          />
        </div>

        <div className="icons-bottom-nav_">
          <NotesMap
            lang={lang}
            isNotesOpen={isNotesOpen}
            onToggleNotes={toggleNotes}
            isOtherOpen={isInfoOpen}
          />
          {!page.includes("/master-plan") && (
            <InfoMap
              lang={lang}
              isInfoOpen={isInfoOpen}
              onToggleInfo={toggleInfo}
              isOtherOpen={isNotesOpen}

              projectSlug={projectSlug}
            />
          )}
          <div className="icon-container" onClick={toggleFullScreen}>
            <img src={assets.maximize} alt="Fullscreen Icon" />
          </div>
        </div>
      </div>
      )}
      <div className="content-nav">
        {/* ✅ الشعار */}
        <div className="name-brand">
          <img
            src={assets.gravity}
            alt="Gravity Logo"
            className="gravity-logo"
          />
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          <div className="icon-container" onClick={toggleFullScreen}>
            <img src={assets.maximize} alt="Fullscreen Icon" />
          </div>
          {/*  الأيقونات */}
          <div className="icons-bottom-nav_">
            <NotesMap
              lang={lang}
              isNotesOpen={isNotesOpen}
              onToggleNotes={toggleNotes}
              isOtherOpen={isInfoOpen}

              projectSlug={projectSlug}
            />

            {!page.includes("/master-plan") && (
              <InfoMap
                lang={lang}
                isInfoOpen={isInfoOpen}
                onToggleInfo={toggleInfo}
                isOtherOpen={isNotesOpen}


                projectSlug={projectSlug}
              />
            )}
          </div>
        </div>
      </div>
      {/*  عناصر الناف */}
      <div className="bottom-items w-100 d-flex d-md-none d-lg-none">
        <ItemNav
          className="no-bg"
          onCallbackClick={onCallbackClick}
          onShowRadiusClick={onShowRadiusClick}
          hideShowRadius={hideShowRadius}
          onToggleOverlay={onToggleOverlay}
          isOverlayHidden={isOverlayHidden}
          onToggleFilter={toggleFilter}
          btnLang={btnLang}
          page={page}
          isBottomNav={true}
          isFilterOpen={isFilterOpen}
          lang={lang}
          onLandmarksClick={onLandmarksClick}
          onRoadsClick={onRoadsClick}
          showPlaces={showPlaces}
          showRoads={showRoads}
          isDevsActive={isDevsActive}
          onDevsClick={onDevsClick}
          onFilterChange={
            page.includes("/master-plan") ? handleFilterChange : undefined
          }
          filterSelection={filterSelection}
          setProgressVilla={setProgressVilla}
          setSpinVilla={setSpinVilla}
          isExploreTour={isExploreTour}
          
        />
      </div>
    </div>
  );
}

export default BottomNav;
